import { Col, Typography } from "antd";
import React from "react";
import BannerCard from "../../common/components/BannerCard";
import getConfigs from "../../GetConfigs"
const Contact = () => {
  const configurations = getConfigs([
    "ctCityName",
    "ctAddress1",
    "ctPhone",
    "ctFax",
    "ctEmail",
    "ctDeptName"
  ]);
  return (
    <>
      <Typography.Title level={4}>
        {configurations.ctCityName} {configurations.ctDeptName} Contact Information
      </Typography.Title>
      <br />
      <Col xl={12} lg={18} md={24} sm={24} xs={24}>
        <BannerCard title="Contact Infomartion">
          <div style={{ lineHeight: "28px" }}>
            <b>To share comments or report problems, please contact :</b>
            <h4>{configurations.ctCityName}</h4>
            <h4>{configurations.ctAddress1}</h4>
            <h4>
              <a href={`tel:${configurations.ctPhone}`}>{configurations.ctPhone}</a>
            </h4>
            <h4>
              <a href={`tel:${configurations.ctFax}`}>{configurations.ctFax}</a>
            </h4>
            <a id="mailto" href={`mailto:${configurations.ctEmail}`} target="_newtab">
              {configurations.ctEmail}
            </a>
          </div>
        </BannerCard>
      </Col>
    </>
  );
};

export default Contact;
